import classNames from 'classnames';
import React from 'react';
import styles from './Subtitle.module.scss';
function Subtitle({ as: Tag = 'h2', size = 'xs', color = 'strong', children }) {
    const classes = classNames(styles.wrap, styles[size], styles[color]);
    return React.createElement(Tag, { className: classes }, children);
}
export default Subtitle;
